module.exports = __webpack_public_path__ + "img/4.7e5368dc.png";